(ns teamoesterreich.user-mode.prevent.prevent-questionnaire-location-summary
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.location-answer-option-ro :as ao]
    [teamoesterreich.util.log :as log]
    ))





(defn get-it []
  (fn []
    (let [q-stars 1
          !selected-questionnaire (r/cursor store/app-state [:state :selected-questionnaire])
          !questionnaire (r/cursor store/app-state [:questionnaires @!selected-questionnaire])
          !selected-location (r/cursor store/app-state [:state :selected-location])
          !questionnaire-response (r/cursor store/app-state [:locations @!selected-location :questionnaires @!selected-questionnaire])
          ]
      (log/debug "act-questionnaire " @!selected-questionnaire @!questionnaire)
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    1
        }

       [mui/grid
        {:container false
         :item      true
         :xs        12
         }
        ""]
       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11
         }

        [mui/card {:class-name "wrap-content-card"}
         [mui/card-content
          [mui/typography {:variant "h4"} (:name @!questionnaire)]
          [:br]
          ;(fq-helper/five-stars-big (fq-helper/get-location-questionnaire-stars locationId questionnaireId)
          [:br]
          "Zusammenfassung"
          [:br]]

         (for [[questionId question] (get-in @!questionnaire [:questions])]
           ^{:key (str "question-" questionId)} [mui/card-content {:key (str "summary_question_" questionId)}
                                                 [mui/typography {:variant "h6"} (str (:question question))]
                                                 [ao/answer-options @!selected-location
                                                  (r/cursor !questionnaire [:questions questionId])
                                                  (r/cursor !questionnaire-response [:questions questionId])]
                                                 ])


         [mui/card-actions
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "center"
            :alignItems "stretch"
            :spacing    1
            }

           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }
            [mui/button
             {:variant   "contained"
              :color     "default"
              :edge      "start"
              :class     "bottom-button"
              :onClick   #(a/set-page-back)
              :startIcon (r/as-element [keyboard-arrow-left])
              }
             "Zurück"]]
           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }

            [mui/button
             {:variant   "contained"
              :edge      "end"
              :color     "primary"
              :class     "bottom-button"
              :onClick   #(a/set-page :prevent-overview :landing)
              :startIcon (r/as-element [keyboard-arrow-right])
              }
             "Fertig"]]]
          ]

         ]]

       ]
      )))

